import {
  GetMonatIsAbgeschlossenQuery,
  GetMonatIsAbgeschlossenQueryVariables,
} from '@/gql/graphql';
import { GET_MONAT_IS_ABGESCHLOSSEN } from '@/hooks/graphql';
import { useSuspenseQuery } from '@apollo/client/react';

export function useIsMonatAbgeschlossen(
  journaltag: string,
  standortId: string,
): boolean {
  const { data, error } = useSuspenseQuery<
    GetMonatIsAbgeschlossenQuery,
    GetMonatIsAbgeschlossenQueryVariables
  >(GET_MONAT_IS_ABGESCHLOSSEN, {
    variables: {
      journaltag: journaltag,
    },
  });
  if (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching data:', error);
    return false;
  }
  if (data.manager.__typename === 'Manager') {
    const currentStandorte = data.manager.standorte.filter(
      (standort) => standort.__typename === 'Standort',
    );

    const currentStandort = currentStandorte.find(
      (standort) => standort.id === standortId,
    );
    if (currentStandort) {
      return currentStandort.isMonatAbgeschlossen ?? false;
    } else {
      // eslint-disable-next-line no-console
      console.error('Standort not found');
      return false;
    }
  }
  return false;
}
